import { render, staticRenderFns } from "./NormalSearchNav147.vue?vue&type=template&id=c70dd5f2&scoped=true"
import script from "./NormalSearchNav147.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav147.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70dd5f2",
  null
  
)

export default component.exports